<template>
  <div class="center-container">
    <div class="head">
      <div class="text">{{ pageTitle }}</div>
    </div>

    <div class="page-bg"></div>

    <div class="paging-box">
      <div class="paging">
        <div
          v-for="(item, index) in categories"
          :key="index"
          class="paging-item"
          :class="item.active ? 'paging-item-active' : ''"
          @click="setActivePaging(index)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="course-list">
      <div
        v-for="(item, index) in filterList"
        v-show="
          item.has_courses !== '' &&
          (!item.hideMineCourse || !item.hideMineExam) &&
          item.is_open == 1
        "
        :key="index"
        class="course-item"
      >
        <div class="title">{{ item.title }}</div>
        <div class="content">
          <div
            v-show="
              !item.hideMineCourse &&
              (item.has_courses == '1' || item.has_courses == '1,2')
            "
            class="content-item divider"
            @click="goOnlineCourse(item)"
          >
            在线课程
          </div>
          <div
            v-show="
              !item.hideMineExam &&
              (item.has_courses == '2' || item.has_courses == '1,2')
            "
            class="content-item"
            :class="{ disabled: item.allow_practise === 0 }"
            @click="goModuleExam(item)"
          >
            章节练习
            <span v-show="item.allow_practise === 0" class="material-icons">
              lock
            </span>
          </div>
          <div
            v-show="
              !item.hideMineExam &&
              (item.has_courses == '2' || item.has_courses == '1,2')
            "
            class="content-item divider"
            :class="{ disabled: item.allow_practise === 0 }"
            @click="goMockExam(item)"
          >
            模拟考试
            <span v-show="item.allow_practise === 0" class="material-icons">
              lock
            </span>
          </div>
          <div class="content-item" @click="goPay(item)">在线购买</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCourseCenter, UserGetSubjectCategories } from '@/api/index'
export default {
  name: 'Center',
  components: {},
  data() {
    return {
      list: [],
      categories: [],
    }
  },
  computed: {
    pageTitle() {
      return this.$root.$data.showMineCourse ? '我的课程' : '课程中心'
    },
    filterList() {
      let result = []
      if (this.$root.$data.showMineCourse) {
        result = this.list.map((item) => {
          item.hideMineCourse = item.isVisible === 0
          if (item.has_courses == '2') {
            item.hideMineCourse = true
          }
          item.hideMineExam = item.allow_practise === 0
          if (item.has_courses == '1') {
            item.hideMineExam = true
          }
          return item
        })
      } else {
        result = this.list
      }
      return result
    },
  },
  watch: {},
  created() {
    this.getSubjectCategories()
  },
  methods: {
    async getSubjectCategories() {
      const data = await UserGetSubjectCategories()
      this.categories = data.map((item) => {
        item.active = false
        return item
      })
      this.setActivePaging()
    },
    setActivePaging(page = 0) {
      this.categories.map((item, index) => {
        item.active = page === index
        return item
      })
      this.fetchData(this.categories[page].id)
    },
    goOnlineCourse(item) {
      this.routePush(item, '/course-chapter-lists?type=1')
    },
    goModuleExam(item) {
      if (this.$courseExamHaveToPay(item)) return
      this.routePush(item, '/course-chapter-lists?type=2')
    },
    goMockExam(item) {
      if (this.$courseExamHaveToPay(item)) return
      this.routePush(item, '/mock-exam')
    },
    goPay(item) {
      this.$router.push({ path: '/order', query: { subject_id: item.id } })
    },
    routePush(item, path) {
      const routeObj = {
        path: path,
        query: {
          subject_id: item.id,
          is_visible: item.isVisible,
          allow_practise: item.allow_practise,
        },
      }

      this.$router.push(routeObj)
    },

    async fetchData(id) {
      const params = {}
      if (id > -1) params.category_id = id
      const data = await fetchCourseCenter(params)
      this.list = data
    },
  },
}
</script>

<style lang="scss" scoped>
.center-container {
  background-color: #f8f8f8;
}

.head {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  background-color: #214ecf;
  color: #fff;
  text-align: center;
}

.page-bg {
  position: fixed;
  top: 30px;
  width: 100%;
  height: 120px;
  // background: #214ecf;
  background-image: url('../assets/images/page-bg.png');
  background-size: 100% 100%;
  z-index: 1;
}

.paging-box {
  padding: 0 14px;

  .paging {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
    margin-top: 8px;
    overflow-x: auto;
    white-space: nowrap;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      color: transparent;
    }
    .paging-item {
      padding: 2px 8px;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 6px;
      margin-right: 8px;
    }
    .paging-item-active {
      background: #fff;
      color: #214ecf;
      font-weight: 600;
    }
  }
}

.course-list {
  padding: 0 20px;
  margin-top: 12px;
  color: #333;
  position: relative;
  z-index: 2;
  .course-item {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 6px 1px rgba(210, 210, 210, 0.8);
    margin-bottom: 12px;
    overflow: hidden;
    .title {
      text-align: start;
      font-size: 16px;
      line-height: 36px;
      color: #000;
      font-weight: 600;
      padding: 2px 0 2px 16px;
      &:before {
        content: '';
        width: 3px;
        height: 14px;
        background: #2287c2;
        display: inline-block;
        margin-right: 8px;
        position: relative;
        top: 1px;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      .content-item {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-basis: 50%;
        background: #fff;
        position: relative;
        border-top: 1px solid #eee;
        border-right: 1px solid #eee;
        color: #214ecf;

        &.disabled {
          color: #bbb;
          background: #f1f4fd;
        }

        &.divider::after {
          content: '';
          display: inline-block;
          width: 1px;
          height: 80%;
          background: #f5f5f5;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }

        .material-icons {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
